/**
 * Дек кандидатов, «Го» и пропуск (CC §6.1–6.4, BS §11.1, §11.4).
 *
 * CC §4.9 п. 8: операции discovery в очередь pending НЕ ставятся — они
 * требуют актуальной проверки допустимости на сервере. Без сети кнопки
 * показывают ожидание, карточка не расходуется.
 *
 * Состояние живёт в `discovery-store.ts`: выдача переживает уход с экрана
 * и возврат (профиль кандидата, фильтры), обновляясь только по явной причине.
 */
import { useCallback, useEffect } from 'react'

import type { Match } from '@shared/api/types'

import { EMPTY_DECK, useDiscoveryStore, type DeckState } from './discovery-store'
import type { LensId } from './lenses'

export interface Discovery extends DeckState {
  lens: LensId
  setLens: (lens: LensId) => void
  like: (userId: string) => Promise<Match | null>
  pass: (userId: string) => Promise<void>
  reload: () => void
}

export function useDiscovery(): Discovery {
  const lens = useDiscoveryStore((s) => s.lens)
  const deck = useDiscoveryStore((s) => s.decks[s.lens] ?? EMPTY_DECK)
  const ensure = useDiscoveryStore((s) => s.ensure)
  const load = useDiscoveryStore((s) => s.load)
  const setLens = useDiscoveryStore((s) => s.setLens)
  const like = useDiscoveryStore((s) => s.like)
  const pass = useDiscoveryStore((s) => s.pass)

  // Первая страница — только если выдачи для линзы ещё нет;
  // после `invalidate` (изменились параметры) выдача пуста и запрашивается заново.
  useEffect(() => ensure(lens), [ensure, lens, deck.loaded, deck.loading])

  const reload = useCallback(() => void load(lens, true), [load, lens])

  return { ...deck, lens, setLens, like, pass, reload }
}
